const messageBoxStyles = (theme) => {
  return {
    container: {
      height: '100%',
      backgroundColor: '#eaeaf0', //564e43--old
      width: '100%',
      display: 'flex',
      flexDirection: 'column-reverse',
      borderWidth: 1,
      borderStyle: 'solid',
      boxShadow: '0 0 6px rgba(0,0,0,0.00)',
      WebkitBoxShadow: '0 0 6px rgba(0,0,0,0.00)',
    },

    inputContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: 'auto',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: '#a9a9a9',
      backgroundColor: '#fff',
      marginLeft: 1,
      marginRight: 1,
      position: 'relative',
    },

    emojiContainer: {
      zIndex: 1,
      position: 'absolute',
      bottom: 0,
      right: 0,
      transform: 'translate(0px,-10%)',
    },

    inputElement: {
      height: '100%',
      width: 'inherit',
      border: 'none',
      flex: 1,
      outline: 1,
      color: '#000',
      padding: 10,
    },

    emojiIcon: {
      padding: '0px !important',
      color: 'grey',
    },

    favouriteIcon: {
      fill: '#FC46AA',
      padding: '0px !important',
    },

    likeIcon: {
      fill: '#5DADE2',
      padding: '0px !important',
    },
  };
};

export default messageBoxStyles;
